import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { ObjectTheme } from "./utils/ObjectTheme";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "theming"
    }}>{`Theming`}</h1>
    <p>{`Violin adds a default style with `}<inlineCode parentName="p">{`GlobalStyle`}</inlineCode>{` component. It's recommended.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { GlobalStyle } from "@involves/violin";

const App = () => {
  return (
    <>
      <GlobalStyle />
      { /** */ }
    </>
  )
}
`}</code></pre>
    <h2 {...{
      "id": "custom-theme"
    }}>{`Custom theme`}</h2>
    <p>{`You can update an specific value from default `}<a parentName="p" {...{
        "href": "#base-theme-object"
      }}>{`theme object`}</a>{` or create new properties and values.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import styled, { ThemeProvider } from "styled-components";
import { createTheme, theme } from "@involves/violin"; 

const myCustomTheme = createTheme({
  palette: {
    primary: theme.palette.purple, // This changes primary color only
    customcolor: "pink" // Add new value for use from theme
  },
});

const CustomTitle = styled.h1\`
  color: \${({ theme }) => theme.palette.customcolor};
\`;

<ThemeProvider theme={myCustomTheme}>
  { /** root component */ }
  <CustomTitle>Lorem ipsum</CustomTitle>
</ThemeProvider>
`}</code></pre>
    <h2 {...{
      "id": "base-theme-object"
    }}>{`Base theme object`}</h2>
    <ObjectTheme mdxType="ObjectTheme" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      